import React from "react";
import { Question, QuestionResponseResult } from "../types";

interface QuestionResponseDisplayProps {
    question: Question | QuestionResponseResult;
    children?: React.ReactNode;
}

export default (props: QuestionResponseDisplayProps) => {

    const { question, children } = props;

    return (
        <div className="flex flex-col w-11/12 p-1 rounded-md capitalize text-white">
            <h3 className="my-7 md:my-10 text-2xl md:text-4xl text-[#3da8e2]">{question.questionText}</h3>
            {children}
        </div>
    )

}